export const getAuthToken = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    return localStorage.getItem("hr_token");
  }
  return null;
};

export const setAuthToken = (token) => {
  if (typeof window !== "undefined" && window.localStorage) {
    localStorage.setItem("hr_token", token);
  }
  return null;
};

export const removeAuthToken = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    localStorage.removeItem("hr_token");
    localStorage.clear();
    localStorage.removeItem("prevPath");
    window.location.reload(false);
  }
  return null;
};
